
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-graphical-abstract",
      function () {
        return require("private-next-pages/create-graphical-abstract.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-graphical-abstract"])
      });
    }
  